import { render, staticRenderFns } from "./OverviewTabContent.vue?vue&type=template&id=432ff524&scoped=true&"
import script from "./OverviewTabContent.vue?vue&type=script&lang=js&"
export * from "./OverviewTabContent.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTabContent.vue?vue&type=style&index=0&id=432ff524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ff524",
  null
  
)

export default component.exports